<template>
  <div class="chart flex-column flex-justify-start flex-align-start" :class="[{'card-gap': gap}]">
    <div class="chart-head flex-row flex-justify-start flex-align-start">电量</div>
    <div class="chart-contain flex-row flex-justify-center flex-align-start">
      <div id="electref" class="chart-area"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'ElectChart',
  props: {
    gap: {
      type: Boolean,
      default: true
    },
    elect: {
      type: Object,
      default: () => ({
        thiselect: [],
        lastelect: []
      })
    }
  },
  data() {
    return {
      electChart: null
    }
  },
  watch: {
    elect: {
      handler() {
        this.$nextTick(() => {
          this.initChart()
        })
      },
      deep: true
    },
  },
  beforeDestroy() {
    if(this.electChart != null) {
      this.electChart.dispose()
      this.electChart = null
    }
  },
  methods: {
    initChart() {
      var chartDom = document.getElementById('electref')
      if(!chartDom) {
        return
      }
      if (!this.electChart) {
        this.electChart = echarts.init(chartDom);
      }
      var option = {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'text-align: left;',
          axisPointer: {
            type: 'none'
          }
        },
        legend: {
          data: ['今年电量', '去年电量']
        },
        xAxis: [
          {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '电量 / kWh',
            // min: 0,
            // max: 1000000,
            // interval: 200000,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '今年电量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' KWh';
              }
            },
            itemStyle: {
              color: '#75b1ff'
            },
            data: this.elect.thiselect
          },
          {
            name: '去年电量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' KWh';
              }
            },
            itemStyle: {
              color: '#ff8a8a'
            },
            data: this.elect.lastelect
          }
        ]
      }
      this.electChart.setOption(option)
    }
  }
}
</script>

<style scoped>
.chart {
  width: 49.5%;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}
.card-gap {
  margin-right: 1%;
}
.chart-head {
  font-family: 'Arial';
  font-size: 18px;
  margin-left: 20px;
  margin-top: 10px;
}
.chart-area {
  min-width: 800px;
  min-height: 400px;
}
.chart-contain {
  width: 100%;
  overflow: hidden;
}
</style>
